module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/core-js/object/set-prototype-of.js
// module id = ../node_modules/babel-runtime/core-js/object/set-prototype-of.js
// module chunks = 0